import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody } from "@chakra-ui/react";
import { FunctionComponent } from "react";
import { CreateOrEditReportForm } from "./CreateOrEditReportForm";
import { ReportByClientId as Report } from "../../../api/reports/reportApi";
import { Jurisdiction } from "../../../api/jurisdictions/jurisdictionApi";
import { Entity } from "../../../api/entities/entityApi";
import { MODAL_CONTENT_SIZING, MODAL_SIZING } from "../../../utils/constants";

interface Props {
    show: boolean;
    onClose: () => void;
    reportData: Report | undefined;
    jurisdictions: Jurisdiction[];
    entities: Entity[];
    reportNames: Report[];
    clientId: string;
    isEdit?: boolean;
}

export const CreateOrEditReportModal: FunctionComponent<Props> = ({
    show,
    onClose,
    reportData,
    jurisdictions,
    entities,
    reportNames,
    clientId,
    isEdit = false,
}: Props) => {
    return (
        <Modal isOpen={show} onClose={onClose} size={MODAL_SIZING} isCentered motionPreset="slideInBottom">
            <ModalOverlay />
            <ModalContent style={{ ...MODAL_CONTENT_SIZING }} overflowY="auto">
                <ModalHeader>
                    <span>{reportData?.id ? "Edit" : "Add"}</span> Report
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody overflowY={"auto"}>
                    <CreateOrEditReportForm
                        onClose={onClose}
                        reportData={reportData}
                        jurisdictions={jurisdictions}
                        entities={entities}
                        existingReports={reportNames}
                        isEdit={isEdit}
                        clientId={clientId}
                    />
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};
